<template>
  <v-app>
    <v-container>
      <v-layout>
        <v-flex sm8 offset-sm2 class="mt-4">
          <v-card>
            <v-card-title primary-title>
              <h3 class="display-1">
                Gritus Client Dashboard
              </h3>
            </v-card-title>
            <v-card-text>
              <v-alert color="error" icon="warning" :value="error" transition="fade-transition">
                Invalid credentials
              </v-alert>
              <form @submit.prevent="submit">
                <v-text-field label="Username"
                              v-model="form.username"
                              required
                ></v-text-field>
                <v-text-field label="password"
                              type="password"
                              v-model="form.password"
                              required
                ></v-text-field>

                <v-btn color="primary" type="submit" :loading="loading">Sign In</v-btn>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
  import mainService from '@/services/main'

  export default {
    data () {
      return {
        form: {
          username: null,
          password: null
        },

        error: false,

        loading: false
      }
    },

    methods: {
      submit () {
        this.error = false
        this.loading = true

        mainService.login(this.form)
          .then(({ headers, data }) => {
            this.$store.commit('LOGIN', headers.authorization.split(' ')[1])

            if (data.data.id) {
              this.$store.commit('USER_ID', data.data.id)
              this.$store.commit('SET_DASHBOARD_URL', data.data.dashboard_url)
              this.$store.commit('SET_REPORT_TYPE', data.data.report_type)
              this.$store.commit('acl/SET_ROLES', data.data.role)
              this.$store.commit('SET_REPORTS', data.data.reports)
            }

            this.$router.replace('/')
          })
          .catch(error => {
            this.error = true
            this.loading = false
            console.log(error)
          })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Login.vue